import { makeAutoObservable } from "mobx";
import { ZIdName } from "src/types/ZIdName";
import { ZUid } from "src/types/zUid";

type PropsFormulaWithFinancialMetaStore = {
  objectOptionsLoader: () => Promise<ZIdName[]>;
  name: string[];
  objectId: ZUid;
  curAttrId: ZUid;
  attrTypesDict: Record<number, string>;
};

export class FormulawithFinancialMetaStore {
  constructor(readonly props: PropsFormulaWithFinancialMetaStore) {
    makeAutoObservable(this);
  }
}
